import './App.css'
import './styles/globals.css'
import { FC, useEffect, useState } from 'react'
import { Route, Routes, useNavigate, useSearchParams } from 'react-router-dom'
import {
    LeaderBoard,
    MyProfile,
    SeasonDetail,
    SeasonSummary,
    EndSeason,
    SeasonRunning,
} from './features'
import { PrizePoolTable } from './features/SeasonDetail/components/PrizePoolTable/PrizePoolTable'
import { appCallbackHandler } from './util/AppCallbackHandler'
import i18n from './config/i18n'
import { BadgeDetails } from './features/BadgeDetails'
import { Button, Form, Input, Modal } from 'antd'

const App: FC<unknown> = () => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()

    const [fontFamily, setFontFamily] = useState<string>('DBAiry')
    const [isUserAuthenticated, setIsUserAuthenticated] =
        useState<boolean>(false)

    useEffect(() => {
        if (i18n.language === 'en') {
            document.documentElement.style.fontSize = '16px'
            setFontFamily('DBAiry')
        } else if (
            i18n.language === 'cn' ||
            i18n.language === 'vn' ||
            i18n.language === 'kr'
        ) {
            document.documentElement.style.fontSize = '12px'
            setFontFamily('NanoSans')
        } else {
            document.documentElement.style.fontSize = '12px'
            setFontFamily('FF-MARK')
        }
    }, [i18n.language])

    useEffect(() => {
        if (
            searchParams.get('l') &&
            (searchParams.get('l') === 'cn' ||
                searchParams.get('l') === 'es' ||
                searchParams.get('l') === 'id' ||
                searchParams.get('l') === 'kr' ||
                searchParams.get('l') === 'pt' ||
                searchParams.get('l') === 'vn')
        ) {
            i18n.changeLanguage(searchParams.get('l') || 'en')
        } else {
            i18n.changeLanguage('en')
        }
    }, [searchParams.get('l')])

    const pageIsLoaded = () => {
        appCallbackHandler('pageIsLoaded')
        console.log('pageIsLoaded method called')
    }

    const sendMobilPageIsLoadedHandler = () => {
        setTimeout(() => pageIsLoaded(), 1000)
    }

    useEffect(() => {
        window !== undefined && sendMobilPageIsLoadedHandler()
        console.log(window, 'window is loaded')
    }, [])

    useEffect(() => {
        if (!window.localStorage.getItem('token')) {
            setIsUserAuthenticated(false)
        } else {
            setIsUserAuthenticated(true)
        }
    }, [window.localStorage.getItem('token')])

    useEffect(() => {
        window.setTokenId = setNewAccessToken
        window.setAppUserId = setNewAppUserId
        window.setMockAccId = setNewMockAccId
        window.setSeasonKeyword = setSeasonKeyword
        window.setTransparentBackground = setTransparentBackground
    }, [])

    const setNewAccessToken = (token: string) => {
        window.localStorage.setItem('token', token)
        window.localStorage.setItem('APP', 'true')

        if (token) {
            setIsUserAuthenticated(true)
            console.log(
                token,
                'USER is authenticated, token id comes from Mobile APP'
            )
        } else {
            console.log('token is not received from Mobile')
        }
    }

    console.log(window?.localStorage?.getItem('token'), 'Current Token')

    const setNewAppUserId = (appUserId: string) => {
        window.localStorage.setItem('APP_USER_ID', appUserId)
        console.log(appUserId, 'APP_USER_ID comes from Mobile APP')
    }

    const setNewMockAccId = (mockAccId: string) => {
        window.localStorage.setItem('MOCK_ACC_ID', mockAccId)
        console.log(mockAccId, 'MOCK_ACC_ID comes from Mobile APP')

        if (mockAccId) {
            setIsUserAuthenticated(true)
            console.log(
                'USER is authenticated, MOCK_ACC_ID comes from Mobile APP'
            )
        } else {
            console.log('mockAccId is not received from Mobile')
        }
    }

    const setSeasonKeyword = (userId: string) => {
        window.localStorage.setItem('SEASON_KEYWORD', userId)
        console.log(userId, 'seasonKeyword  comes from Mobile APP')
    }

    const setTransparentBackground = (transparent: boolean) => {
        window.localStorage.setItem('TRANSPARENT', 'transparent')
        console.log(transparent, 'transparent  comes from Mobile APP')
    }

    const onFinish = (values: any) => {
        window.localStorage.setItem('token', values.token)
        window.localStorage.setItem('MOCK_ACC_ID', values.mockAccId)
        setIsUserAuthenticated(true)
        navigate('/')
    }

    const onFinishFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo)
    }

    return (
        <>
            {!isUserAuthenticated &&
            (window.location.hostname.includes('staging') ||
                window.location.hostname.includes('localhost')) ? (
                <Modal
                    footer={null}
                    title={<label style={{ color: '#10F48B' }}>Login</label>}
                    open={true}
                >
                    <Form
                        name="basic"
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 16 }}
                        initialValues={{ remember: true }}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                    >
                        <Form.Item
                            label={
                                <label style={{ color: '#10F48B' }}>
                                    Access Token
                                </label>
                            }
                            name="token"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your username!',
                                },
                            ]}
                        >
                            <Input.Password />
                        </Form.Item>

                        <Form.Item
                            label={
                                <label style={{ color: '#10F48B' }}>
                                    Mock ACCOUNT ID
                                </label>
                            }
                            name="mockAccId"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your password!',
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                            <Button type="primary" htmlType="submit">
                                Submit
                            </Button>
                        </Form.Item>
                    </Form>
                </Modal>
            ) : (
                <div style={{ fontFamily: fontFamily }}>
                    <Routes>
                        <Route path="/" element={<LeaderBoard />} />
                        <Route
                            path="season-detail"
                            element={<SeasonDetail />}
                        />
                        <Route
                            path="season-summary"
                            element={
                                <SeasonSummary isAuth={isUserAuthenticated} />
                            }
                        />
                        <Route
                            path="season-calculating"
                            element={<SeasonRunning />}
                        />
                        <Route path="end-season" element={<EndSeason />} />
                        <Route path="my-profile" element={<MyProfile />} />
                        <Route path="prize-pool" element={<PrizePoolTable />} />
                        <Route path="badge-detail" element={<BadgeDetails />} />

                        <Route
                            path="*"
                            element={
                                <main style={{ padding: '1rem' }}>
                                    <p>There's nothing here!</p>
                                </main>
                            }
                        />
                    </Routes>
                </div>
            )}
        </>
    )
}

export default App
